module.exports = __webpack_public_path__ + "img/delete.0f6f53ea.svg";